import { type FC } from 'react'
import { type DefaultProps } from '@egw/components'

export const CableIcon: FC<DefaultProps> = ({ className, id, testId, ariaLabel }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill="none"
      className={className}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      <g clipPath="url(#a)">
        <path
          fill="#698679"
          d="M9.617 7.715c-.081 0-.162.006-.242.017a2.012 2.012 0 0 0-1.888-1.489 2.358 2.358 0 0 0-4.403.73 2.018 2.018 0 1 0-.317 4.01h6.85a1.634 1.634 0 1 0 0-3.268Z"
        />
        <g clipPath="url(#b)">
          <path
            fill="#698679"
            fillRule="evenodd"
            d="M10.706 5.124a3.828 3.828 0 0 0-3.828-3.828.328.328 0 0 1 0-.657 4.484 4.484 0 0 1 4.484 4.485.328.328 0 1 1-.656 0Zm-1.313 0a2.516 2.516 0 0 0-2.515-2.516.328.328 0 0 1 0-.656 3.172 3.172 0 0 1 3.172 3.172.328.328 0 1 1-.657 0Zm-1.312 0c0-.665-.539-1.203-1.203-1.203a.328.328 0 0 1 0-.657 1.86 1.86 0 0 1 1.86 1.86.328.328 0 1 1-.657 0Z"
            clipRule="evenodd"
          />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h12v12H0z" />
        </clipPath>
        <clipPath id="b">
          <path fill="#fff" d="m8.5-1.45 4.95 4.95L8.5 8.45 3.55 3.5z" />
        </clipPath>
      </defs>
    </svg>
  )
}
